module.exports = {
      id: "share-link-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#share-link",
      toString: function () {
        return this.url;
      }
    }